import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"
const firebaseConfig = {
  apiKey: "AIzaSyAuhzVViU8fV3nuiH2VxsgVRPQde16-0h0",
  authDomain: "krishnacomputer-469a5.firebaseapp.com",
  databaseURL: "https://krishnacomputer-469a5-default-rtdb.firebaseio.com",
  projectId: "krishnacomputer-469a5",
  storageBucket: "krishnacomputer-469a5.appspot.com",
  messagingSenderId: "1010661337343",
  appId: "1:1010661337343:web:de8e89ea5eb25608fe04ca"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);